import SHARED from '../constants';
import SharedFunc from './SharedFunc';

const findDownloadPath = (item) => {
  let path = '';

  item?.file?.fileExtension?.type == 'image' &&
    (path = SHARED?.socketServerImage);

  item?.file?.fileExtension?.type == 'video' &&
    // (path = SHARED?.socketServerVideo);
    (path==SharedFunc(item?.file?.serverId,'socketServerVideo'))

  item?.file?.fileExtension?.type == 'music' &&
    (path = SharedFunc(item?.file?.serverId,'socketServerMusic'));
  item?.file?.fileExtension?.type == 'zip' && (path = SharedFunc(item?.file?.serverId,'socketServerFile'));
  item?.file?.fileExtension?.type == 'rar' && (path = SharedFunc(item?.file?.serverId,'socketServerFile'));

  item?.file?.fileExtension?.type == 'doc' && (path = SharedFunc(item?.file?.serverId,'socketServerFile'));

  item?.file?.fileExtension?.type == 'pdf' && (path = SharedFunc(item?.file?.serverId,'socketServerFile'));
  return path;
};
export default findDownloadPath;
